import React from "react";
import { WidgetInputProps, WidgetInputText } from "../../types";
import { WidgetInputLabel } from "@fidget/common/components/chat/widgetInputLabel/widgetInputLabel";
import { WidgetFormTextInput } from "@fidget/common/components/chat/widgetFormTextInput/widgetFormTextInput";

interface Props extends WidgetInputProps {
  input: WidgetInputText;
}
export const TextInput = ({ input, isSubmitted, onChange, userAnswers }: Props) => {
  return (
    <div>
      <WidgetInputLabel text={input.displayName} />
      <WidgetFormTextInput
        disabled={isSubmitted}
        value={userAnswers[input.name]?.value || ""}
        onChange={(e) =>
          onChange({ inputName: input.name, value: (e.target as HTMLTextAreaElement).value })
        }
        placeholder={input.placeholder}
        maxLength={input.maxLength}
      />
    </div>
  );
};
